module.exports = __webpack_public_path__ + "img/stomerij.52d072d8.png";